import { Button as MuiButton, type ButtonProps as MuiButtonProps } from '@mui/material';

export function Button({ ...props }: MuiButtonProps) {
  return <MuiButton {...props} />;
}
